import * as React from "react";
import { Breadcrumb, Button, Col, Input, Row, Select } from "antd";
import { Link } from "react-router-dom";
import { FetchWithAuth } from "digimaker-ui/util";
import DataSource from "../lib/DataSource";
import { util } from "../lib/Util";

import { exportToExcel } from "../lib/exportExcel";

const { Option } = Select;

export default class StudentFilter extends React.Component<
  { afterAction: any },
  {
    firstname: string;
    lastname: string;
    input: string;
    course: any;
    intake: any;
    stage: any;
    agency: any;
    status: any;
    courseList: any;
    agencyList: any;
  }
> {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      input: "",
      course: "",
      stage: "",
      agency: "",
      intake: "",
      status: "",
      courseList: [],
      agencyList: [],
    };
  }

  componentDidMount() {
    FetchWithAuth(
      "content/list/course?parent=468&level=1&sortby=c.name%20asc&limit=100",
    ).then((data) => {
      this.setState({ courseList: data.data.list });
    });

    DataSource.loadList("agency", "", 0, 100).then((data) => {
      this.setState({ agencyList: data.list });
    });
  }

  buildFilter() {
    let filterData = {};
    if (this.state.input) {
      filterData["field.student_no"] = "contain:" + this.state.input;
    }
    if (this.state.firstname) {
      filterData["field.firstname"] = "contain:" + this.state.firstname;
    }
    if (this.state.course) {
      filterData["field.course"] = this.state.course;
    }
    if (this.state.lastname) {
      filterData["field.firstname"] = "contain:" + this.state.lastname;
    }
    if (this.state.intake) {
      filterData["field.intake"] = "contain:" + this.state.intake;
    }
    if (this.state.stage) {
      filterData["field.stage"] = this.state.stage;
    }
    if (this.state.agency) {
      filterData["field.agency"] = this.state.agency;
    }
    if (this.state.status) {
      filterData["field.status"] = this.state.status;
    }
    return filterData;
  }

  filter(empty?: boolean) {
    let filterData = {};
    if (!empty) {
      filterData = this.buildFilter();
    }
    this.props.afterAction(true, { filter: filterData });
  }

  reset() {
    this.filter(true);
    this.setState({ firstname: "", lastname: "", intake: "", input: "" });
  }

  async download() {
    const filter = this.buildFilter();
    let arr: any = [];
    for (const key of Object.keys(filter)) {
      arr.push(key + "=" + filter[key]);
    }
    let res = await FetchWithAuth(
      "/content/list/student?limit=0&" + arr.join("&"),
    );
    let list = res.data.list;

    for (let i in list) {
      const course = this.state.courseList.find(
        (item) => item.id == list[i].course,
      );
      list[i]["course_name"] = course ? course.name : "";
      const agency = this.state.agencyList.find(
        (item) => item.id == list[i].agency,
      );
      list[i]["agency_name"] = agency ? agency.name : "";
    }

    exportToExcel(
      list,
      [
        { label: "Student NO.", value: "student_no" },
        { label: "First Name", value: "firstname" },
        { label: "Last Name", value: "lastname" },
        { label: "DOB", value: (row) => row["birthdate"].split("T")[0] },
        { label: "Intake", value: "intake" },
        { label: "Course", value: "course_name" },
        { label: "Agency", value: "agency_name" },
        { label: "Stage", value: "stage" },
        { label: "Telephone", value: "telephone" },
        { label: "Sex", value: "sex" },
        { label: "Nationality", value: "nationality" },
        { label: "Email", value: "email" },
        { label: "Address 1", value: "address1" },
        { label: "Address 2", value: "address2" },
        { label: "Address 3", value: "address3" },
        { label: "Address 4", value: "address4" },
        { label: "Status", value: "status" },
      ],
      "Student List",
      "Student List",
    );
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={{ float: "right", gap: "10px", display: "flex" }}>
          <Link to="/student/create">
            <i className="icon fas fa-user"></i>Add student
          </Link>
          <Link to="/import/students">
            <i className="icon fas fa-upload"></i>Import
          </Link>
        </div>
        <form
          onSubmit={(e) => {
            this.filter();
            e.preventDefault();
          }}
        >
          <Row style={{ marginTop: "5px" }}>
            <Col span={8}>
              <label>Course: </label>
              <Select
                defaultValue={""}
                style={{ width: "250px" }}
                onChange={(v) => this.setState({ course: v })}
              >
                <Option value="">All</Option>
                {this.state.courseList.map((item) => (
                  <Option value={item.cid}>{item.name}</Option>
                ))}
              </Select>
            </Col>
            <Col span={4}>
              <label>Stage: </label>
              <Select
                defaultValue={""}
                onChange={(v) => this.setState({ stage: v })}
              >
                <Option value="">All</Option>
                <Option value={1}>1</Option>
                <Option value={2}>2</Option>
                <Option value={3}>3</Option>
                <Option value={4}>4</Option>
              </Select>
            </Col>
            <Col span={4}>
              <label>Agency: </label>
              <Select
                defaultValue={""}
                style={{ width: "100px" }}
                onChange={(v) => this.setState({ agency: v })}
              >
                <Option value="">All</Option>
                {this.state.agencyList.map((item) => (
                  <Option value={item.id}>{item.name}</Option>
                ))}
              </Select>
            </Col>
            <Col span={6}>
              <label>Status: </label>
              <Select
                defaultValue={""}
                style={{ width: "180px" }}
                onChange={(v) => this.setState({ status: v })}
              >
                <Option value="">All</Option>
                {util.statusList.map((status) => (
                  <Option value={status}>{status}</Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={4}>
              <Input
                value={this.state.firstname}
                placeholder="First name"
                onChange={(e) => this.setState({ firstname: e.target.value })}
              />
            </Col>
            <Col span={4}>
              <Input
                value={this.state.lastname}
                placeholder="Last name"
                onChange={(e) => this.setState({ lastname: e.target.value })}
              />
            </Col>
            <Col span={4}>
              <Input
                value={this.state.input}
                placeholder="Student No."
                onChange={(e) => this.setState({ input: e.target.value })}
              />
            </Col>
            <Col span={4}>
              <label>Intake: </label>
              <Input
                style={{ width: "100px" }}
                value={this.state.intake}
                placeholder="Intake"
                onChange={(e) => this.setState({ intake: e.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              &nbsp;
              <Button type="primary" htmlType="submit">
                Submit
              </Button>{" "}
              &nbsp;
              <Button type="link" onClick={() => this.reset()}>
                Reset
              </Button>
              &nbsp;&nbsp;
              <Button onClick={() => this.download()}>Download</Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}
